import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

// Define a generic type for the Axios response
type AxiosQueryFunction<T> = (config: AxiosRequestConfig) => Promise<T>;

// Default Axios query function
const defaultQueryFn: AxiosQueryFunction<any> = async ({ url, ...config }) => {
  const response: AxiosResponse = await axios({ url, ...config });
  return response.data;
};

// Extended useAppQuery hook
export function useAppQuery<TData = unknown, TError = unknown>(
  queryKey: string[],
  config: AxiosRequestConfig,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>
): UseQueryResult<TData, TError> {
  return useQuery<TData, TError>({
    queryKey,
    queryFn: () => defaultQueryFn(config),
    ...options,
  });
}
